import clearLocalStorage from "#/utils/clearLocalStorage";
import { useCartStore } from "../../store/cart";
import type { PaymentConfig, PaymentHandler } from "../../types/payment";
import { createPaymentErrorHandler } from "../services/PaymentErrorHandler";
import { checkOrderStatus, clearSavedData, closeWebSocket, handleOrderError, handleOrderPay, handleRmsDiscounts } from "./basePaymentHandler";

export const createYoukassaHandler = (): PaymentHandler => {
	const storeCart = useCartStore();
	const ws: any | null = null;
	const errorHandler = createPaymentErrorHandler();

	/** Обработка статусов WebSocket для Youkassa */
	const handleWebSocketStatus = (data: any, config: PaymentConfig): void => {
		const status = data.params?.status;

		if (status === "sent") {
			handleRmsDiscounts(data, config);
			storeCart.isButtonDisabled = false;
		} else if (status === "payment_initiation_retry" || status === "fiscalized") {
			handleOrderPay(data, config, ws, errorHandler);
		} else if (status === "payment_initiation") {
			checkOrderStatus(config, 2);
		} else if (status === "paid") {
			checkOrderStatus(config, 3);
			const wsToUse = config.ws || ws;
			closeWebSocket(wsToUse);
			storeCart.tabName = null;
			storeCart.isAdultConfirmed = false;
			clearLocalStorage(["cart"]);
			clearSavedData();
		} else if (config.orderErrors?.includes(status)) {
			storeCart.isButtonDisabled = false;
			handleOrderError(data, config, ws, errorHandler);
		}
	};

	return {
		handleWebSocketStatus(data: any, config: PaymentConfig): void {
			handleWebSocketStatus(data, config);
		},
	};
};
